import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import 'malihu-custom-scrollbar-plugin';

gsap.registerPlugin(ScrollTrigger);

$(document).ready(function () {
    const MOBILE_BREAKPOINT = 768; // width under which we treat as mobile
    const OFFSET = 10;            // extra offset for header spacing

    const anchorBar     = $('.floating-anchor-bar');
    const anchorContent = anchorBar.find(".content-wrap");
    const anchorBox     = anchorBar.find(".anchors-box");
    const anchors       = anchorBar.find(".anchors");
    const siteHeader    = $(".header-fixed");
    let headerHeight    = siteHeader.innerHeight();

    // Create ScrollTriggers for anchors
    const triggers = [];

    // Handle scroll position and fixed state
    function scrTop() {
        const scrollY = $(window).scrollTop() + headerHeight + OFFSET;
        const offsetY = anchorContent.offset().top;
        headerHeight = siteHeader.innerHeight();
        anchorBox.toggleClass("-fixed", scrollY >= offsetY)
            .css("top", anchorBox.hasClass("-fixed") ? headerHeight + "px" : "0");
    }

    // Center or left-align anchors based on width
    function adjustAnchorWrap() {
        const wrapWidth   = anchors.outerWidth();
        const windowWidth = $(window).width();
        anchors.css({
            left:      wrapWidth >= windowWidth ? 0 : "50%",
            transform: wrapWidth >= windowWidth ? "none" : "translateX(-50%)"
        });
    }

    // Initialize or update custom scrollbar
    function initScrollbar() {
        anchors.each(function () {
            const $el = $(this);
            if (!$el.data("mCS")) {
                $el.mCustomScrollbar({
                    axis: "x",
                    theme: "my-theme",
                    documentTouchScroll: true,
                    contentTouchScroll: true,
                    advanced: { autoExpandHorizontalScroll: 2 }
                });
            }
            $el.mCustomScrollbar("update");
        });
    }

    // Center the active link in the scrollbar container (mobile only)
    function centerActiveLink(link) {
        if ($(window).width() > MOBILE_BREAKPOINT) return;

        const $link           = $(link);
        const $container      = anchors;
        const containerWidth  = $container.width();
        const linkPos         = $link.position().left;
        const linkWidth       = $link.outerWidth(true);


        const centerCalc = containerWidth / 2 - linkWidth / 2 - 12;

        // Calculate scroll offset to center the link
        let scrollToX = linkPos - centerCalc;

        if(linkPos < centerCalc) {
            scrollToX = 0;
        }

        $container.mCustomScrollbar("scrollTo", `${scrollToX}px`, {
            axis: "x",
            scrollInertia: 300
        });
    }

    anchorBox.find(".anchor-link").each(function () {
        const link            = this;
        const targetSelector  = link.getAttribute("href");
        const sectionElement  = targetSelector ? document.querySelector(targetSelector) : '';
        if (!sectionElement) return;

        const trigger = ScrollTrigger.create({
            trigger: sectionElement,
            start:   () => `top ${siteHeader.innerHeight() + OFFSET}px`,
            end:     () => `bottom ${siteHeader.innerHeight() + OFFSET}px`,
            toggleClass: { targets: link, className: "active" },
            onEnter:     () => centerActiveLink(link),
            onEnterBack: () => centerActiveLink(link),
            // markers: true, // uncomment for debugging
        });

        triggers.push(trigger);
    });

    // Setup initial state and event listeners
    scrTop();
    adjustAnchorWrap();
    initScrollbar();

    $(window).on('scroll resize', function () {
        triggers.forEach(t => t.refresh());
        scrTop();
        adjustAnchorWrap();
    });
});
